<template>
    <div>
        <loadScreenComponent></loadScreenComponent>
        <pageHeader :pageTitle="this.companyTitle" :subTitle="getCompanyId()"></pageHeader>
        <div class="card">
            <div class="card-body">
                <div class="row gutters">
                    <div class="col-xl-4 col-lg-3 col-md-3 col-sm-6 col-12">
                        <div class="form-group">
                            <label for="">{{ this.t('COMPANY.NAME') }}</label>
                            <input type="text" class="form-control" v-model="iten.name"
                                   :disabled="!this.$hasPermission('security_company_update')">
                            <div class="validation" id="invalidName" v-if="msgInvalid.name">
                                {{ t(msgInvalid.name) }}
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12">
                        <div class="form-group">
                            <label for="">{{ this.t('COMPANY.CORPORATE_NAME') }}</label>
                            <input type="text" class="form-control" v-model="iten.corporate_name"
                                   :disabled="!this.$hasPermission('security_company_update')">
                            <div class="validation" id="invalidCorporateName" v-if="msgInvalid.corporate_name">
                                {{ t(msgInvalid.corporate_name) }}
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12">
                        <div class="form-group">
                            <label for="">{{ this.t('COMPANY.TAXPAYER') }}</label>
                            <input type="text" class="form-control" v-model="iten.taxpayer"
                                   :disabled="!this.$hasPermission('security_company_update')">
                            <div class="validation" id="invalidTaxpayer" v-if="msgInvalid.taxpayer">
                                {{ t(msgInvalid.taxpayer) }}
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-2 col-lg-3 col-md-3 col-sm-6 col-12 d-flex justify-content-left">
                        <div class="custom-control custom-switch  align-self-center text-left">
                            <input data-cy="user_index_disable" type="checkbox"
                                   class="custom-control-input"
                                   id="active" :disabled="!this.$hasPermission('security_company_update')"
                                   v-model="iten.active">
                            <label data-cy="user_index_label" class="custom-control-label"
                                   for="active">{{ this.t('COMPANY.ACTIVE') }}</label>
                        </div>
                    </div>
                    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                        <phone-component :phonesIndex="iten.phones" :is-view="!this.$hasPermission('security_company_update')"
                                         @update="updatePhone($event)">
                        </phone-component>
                    </div>
                    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                        <email-component :emailsIndex="iten.emails" @delete="deleteEmail" :is-view="!this.$hasPermission('security_company_update')"></email-component>
                    </div>
                    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 d-flex justify-content-end mt-2"
                         v-if="this.$hasPermission('security_company_update')">
                        <button class="btn-primary btn" @click="updateCompany">{{ t('ACTIONS.SAVE') }}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {useI18n} from 'vue-i18n';
import {useToast} from 'vue-toastification';
import pageHeader from "@/components/layouts/pageHeader";
import loadScreenComponent from '../../components/layouts/loadScreenComponent';
import Companies from '../../services/Companies';
import phoneComponent from '../../components/layouts/phoneComponent';
import emailComponent from '../../components/layouts/emailComponent';

export default {
    name: "ShowUpdateCompanyComponent",
    setup() {
        const {t} = useI18n();
        const toast = useToast();
        return {t, toast}
    },
    components: {
        pageHeader,
        loadScreenComponent,
        phoneComponent,
        emailComponent,
    },
    data() {
        return {
            iten: {},
            msgInvalid: {},
            phonesBackup: [],
            companyTitle: "",
        }
    },
    mounted() {
        this.showCompany();
    },
    methods: {
        getCompanyId()
        {
            let id = localStorage.getItem('companyId');
            if (id){
                return id
            }
            return "";
        },
        deleteEmail(email) {
            if (email.id) {
                if (!this.iten.emailsDelete?.length)
                    this.iten.emailsDelete = [];
                this.iten.emailsDelete.push({id: email.id});
            }
        },
        updatePhone(phones) {
            if (!this.iten.phonesDelete?.length) {
                this.iten.phonesDelete = [];
            }
            this.phonesBackup.forEach(i => {
                if (i.id) {
                    let phoneDeleted = phones.find(p => p.id === i.id);
                    let alheady = this.iten.phonesDelete.find(pd => pd.id === i.id);
                    if (!phoneDeleted && !alheady) {
                        this.iten.phonesDelete.push(i);
                    }
                }
            })
            this.iten.phones = phones;
        },
        updateCompany() {
            if (this.validateCompany()) {
                this.$store.commit('changeLoading', true);
                Companies.update(this.iten).then(() => {
                    this.toast.success('Registro Atualizado com Sucesso!');
                    this.$store.commit('changeLoading', false);
                }).catch(err => {
                    this.errorMsg(err);
                    this.$store.commit('changeLoading', false);
                })
            }
        },
        validateCompany() {
            let valid = true;
            if (!this.iten.name) {
                this.msgInvalid.name = "Campo Obrigatório";
                valid = false;
            } else {
                this.msgInvalid.name = null;
            }

            if (!this.iten.corporate_name) {
                this.msgInvalid.corporate_name = "Campo Obrigatório";
                valid = false;
            } else {
                this.msgInvalid.corporate_name = null;
            }

            if (!this.iten.taxpayer) {
                this.msgInvalid.taxpayer = "Campo Obrigatório";
                valid = false;
            } else {
                this.msgInvalid.taxpayer = null;
            }
            return valid;
        },
        showCompany() {
            this.$store.commit('changeLoading', true);
            Companies.showCompanyByToken().then(resp => {
                this.iten = resp.data;
                this.phonesBackup = JSON.parse(JSON.stringify(resp.data.phones));
                this.companyTitle = `${this.iten.name}`;
                this.$store.commit('changeLoading', false);
            }).catch(err => {
                this.$store.commit('changeLoading', false);
                this.errorMsg(err);
            })
        }
    }
}
</script>

<style scoped>

</style>